import { getI18n } from "@editor/ui-utils";
const de = {
  channelizerApi: {
    createAlreadyExists: "Channelizer kann nicht erstellt werden, da bereits ein Channelizer mit diesem Namen existiert",
    updateAlreadyExists: "Channelizer kann nicht aktualisiert werden, da bereits ein Channelizer mit diesem Namen existiert",
    created: "Channelizer erstellt",
    updated: "Channelizer aktualisiert",
    notFound: "Channelizer nicht gefunden",
    requiredFields: "Sie können den Channelizer nicht speichern, da obligatorische Informationen fehlen"
  },
  channelizerList: {
    newButton: "Neuer Channelizer",
    name: "Nach Channelizer-Name suchen",
    deleteChannelizer: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade Channelizer",
    headerLabel: "Channelizer-Name",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createChannelizer: "Channelizer erstellen"
  },
  channelizer: {
    channelizerLabel: "Channelizer",
    backButton: "Zurück zur Channelizer-Liste",
    newChannelizer: "Neuer Channelizer",
    messageDeleteChannelizer: "Channelizer löschen",
    messageDeleteChannelizerTitle: "Sind Sie sicher, dass Sie dieses Channelizer löschen möchten?",
    deleteChannelizer: "Löschen",
    messageDeleted: "Channelizer gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des Channelizers",
    errorFailedLoadedChannelizerWithId: "Es gab einen Fehler beim Abrufen des Channelizers"
  },
  channelizerEdit: {
    label: "Bezeichnung",
    goToPage: "Zur Seite",
    backButton: "Zurück zur Channelizer-Liste",
    editChannelizer: "Channelizer bearbeiten",
    messageSaved: "Neuer Channelizer gespeichert",
    generalSettings: "Allgemeine Einstellungen",
    title: "Channelizer Titel",
    seoTitle: "SEO Titel",
    seoDescription: "SEO Beschreibung",
    canonicalUrl: "URL der Subdomain",
    showCopyright: "Copyright zeigen",
    partnerBannerSettings: "Partner Banner Einstellungen",
    partnerOfferText: "Partnerangebot Text",
    partnerOfferTextTooltip: "Wenn leer, wird kein Text angezeigt.",
    partnerOfferImageUrl: "Partnerangebot Bild URL",
    partnerOfferImageUrlTooltip: "Diese URL muss eine gültige Bild-URL sein. Wenn leer, wird kein Bild angezeigt.",
    advancedSettings: "Erweiterte Einstellungen",
    contentPassEnabled: "Content Pass aktiviert",
    consentEnabled: "Einwilligung aktiviert",
    trackingEnabled: "Tracking aktiviert",
    footerSettings: "Fußzeile Einstellungen",
    imprintUrl: "Eigene Impressum URL",
    conditionsUrl: "Eigene AGB URL",
    contactUrl: "Eigene Kontakt URL",
    dataPrivacyUrl: "Eigene Datenschutz URL",
    footerTooltip: "Wenn leer, dann wird die Standard-URL verwendet."
  }
};
const en = {
  channelizerApi: {
    createAlreadyExists: "Can't create Channelizer because another Channelizer with this name already exists",
    updateAlreadyExists: "Can't update Channelizer because another Channelizer with this name already exists",
    created: "Channelizer created",
    updated: "Channelizer updated",
    notFound: "Channelizer not found",
    requiredFields: "You can't save the Channelizer because mandatory information is missing"
  },
  channelizerList: {
    newButton: "New Channelizer",
    name: "Search by label",
    deleteChannelizer: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading Channelizer",
    headerLabel: "Channelizer Title",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createChannelizer: "Create Channelizer"
  },
  channelizer: {
    channelizerLabel: "Channelizer",
    backButton: "Back to Channelizer list",
    newChannelizer: "New Channelizer",
    messageDeleteChannelizer: "Delete Channelizer",
    messageDeleteChannelizerTitle: "Are you sure you want to delete this Channelizer?",
    deleteChannelizer: "Delete",
    messageDeleted: "Channelizer Deleted",
    errorOnDeleting: "There was an error deleting the Channelizer ",
    errorFailedLoadedChannelizerWithId: "There was an error getting the Channelizer"
  },
  channelizerEdit: {
    label: "Label",
    goToPage: "To the page",
    backButton: "Back to Channelizer list",
    editChannelizer: "Edit Channelizer",
    messageSaved: "New Channelizer saved",
    generalSettings: "General Settings",
    title: "Channelizer Title",
    seoTitle: "SEO Title",
    seoDescription: "SEO Description",
    canonicalUrl: "URL of the subdomain",
    showCopyright: "Show copyright",
    partnerBannerSettings: "Partner Banner Settings",
    partnerOfferText: "Partner Offer Text",
    partnerOfferTextTooltip: "If empty, no text will be displayed.",
    partnerOfferImageUrl: "Partner Offer Image URL",
    partnerOfferImageUrlTooltip: "This URL needs to be a valid image URL. If empty, no image will be displayed.",
    advancedSettings: "Advanced Settings",
    contentPassEnabled: "Content Pass Enabled",
    consentEnabled: "Consent Enabled",
    trackingEnabled: "Tracking Enabled",
    footerSettings: "Footer Settings",
    imprintUrl: "Custom Imprint URL",
    conditionsUrl: "Custom Terms and Conditions URL",
    contactUrl: "Custom Contact URL",
    dataPrivacyUrl: "Custom Data Privacy URL",
    footerTooltip: "If empty, the default URL will be used."
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/channelizer",
    children: [
      {
        path: "",
        name: "channelizer_list",
        component: () => import("./channelizer-list.view-C5ktKMny.js"),
        meta: { requiredRight: "navigate_list_channelizer" }
      },
      {
        path: "new",
        name: "channelizer_new",
        component: () => import("./channelizer-edit.view-0etGsNGe.js"),
        props: () => ({ title: getI18n().t("channelizer.newChannelizer") }),
        meta: { requiredRight: ["navigate_channelizer"] }
      },
      {
        path: ":id",
        name: "channelizer_detail",
        component: () => import("./channelizer-edit.view-0etGsNGe.js"),
        props: (route) => ({
          title: getI18n().t("channelizerEdit.editChannelizer"),
          id: route.params.id,
          backRoute: "/channelizer"
        }),
        meta: { requiredRight: ["navigate_channelizer"] }
      }
    ]
  }
];
const channelizerModule = {
  messages,
  routes
};
export {
  channelizerModule
};
//# sourceMappingURL=index.es.js.map
